import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlNavIconDropdownProps } from './nav-icon.props';
import { getGlobalStyleSheets } from '../../../global-styles';
import '../../dropdownmenu';

import * as TagNames from '../layouts.tagnames';

@customElement(TagNames.NavIconDropdown)
export class AtlNavIconDropdown
   extends LitElement
   implements AtlNavIconDropdownProps
{
   declare containerId: string;
   declare refId: string;
   declare name: string;
   declare applyLeft?: boolean;

   static properties = {
      containerId: { type: String },
      refId: { type: String },
      name: { type: String },
      applyLeft: { type: Boolean },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      return html`
         <atlantis-drop-down-menu
            containerId=${`nav-icon-${this.name}`}
            refId=${this.refId}
            ?applyLeft=${this.applyLeft === true}
         >
            <div slot="slotMenuIcon">
               <slot name="slotMenuIcon"></slot>
            </div>
            <div slot="slotMenuContent">
               <slot name="slotMenuContent"></slot>
            </div>
         </atlantis-drop-down-menu>
      `;
   }
}
